import { CompanyMembersContent } from "../../features/companyWorkspace";

function CompanyMembersScreen() {
  return <CompanyMembersContent />;
}

export default CompanyMembersScreen;
